import { render, staticRenderFns } from "./StartFromSelection.vue?vue&type=template&id=53ebc500&"
import script from "./StartFromSelection.vue?vue&type=script&lang=js&"
export * from "./StartFromSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports